"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectClassNamesFromSubtree = collectClassNamesFromSubtree;
exports.copyTo = copyTo;
exports.enable = enable;
exports.getDocument = getDocument;
exports.getOuterHTML = getOuterHTML;
exports.moveTo = moveTo;
exports.performSearch = performSearch;
exports.getSearchResults = getSearchResults;
exports.pushNodesToFrontend = pushNodesToFrontend;
exports.discardSearchResults = discardSearchResults;
exports.pushNodesByBackendIdsToFrontend = pushNodesByBackendIdsToFrontend;
exports.removeNode = removeNode;
exports.requestChildNodes = requestChildNodes;
exports.requestNode = requestNode;
exports.resolveNode = resolveNode;
exports.setAttributesAsText = setAttributesAsText;
exports.setAttributeValue = setAttributeValue;
exports.setInspectedNode = setInspectedNode;
exports.setNodeValue = setNodeValue;
exports.setOuterHTML = setOuterHTML;
exports.getDOMNodeId = getDOMNodeId;
exports.getDOMNode = getDOMNode;
exports.getTopLayerElements = getTopLayerElements;
exports.getNodesForSubtreeByStyle = getNodesForSubtreeByStyle;
var connector_1 = __importDefault(require("../lib/connector"));
var nodeManager = __importStar(require("../lib/nodeManager"));
var nodeManager_1 = require("../lib/nodeManager");
var objManager = __importStar(require("../lib/objManager"));
var mutationObserver_1 = __importDefault(require("../lib/mutationObserver"));
var _1 = __importDefault(require("licia/$"));
var isNull_1 = __importDefault(require("licia/isNull"));
var isEmpty_1 = __importDefault(require("licia/isEmpty"));
var html_1 = __importDefault(require("licia/html"));
var map_1 = __importDefault(require("licia/map"));
var unique_1 = __importDefault(require("licia/unique"));
var contain_1 = __importDefault(require("licia/contain"));
var lowerCase_1 = __importDefault(require("licia/lowerCase"));
var each_1 = __importDefault(require("licia/each"));
var toArr_1 = __importDefault(require("licia/toArr"));
var xpath_1 = __importDefault(require("licia/xpath"));
var concat_1 = __importDefault(require("licia/concat"));
var evaluate_1 = require("../lib/evaluate");
var util_1 = require("../lib/util");
function collectClassNamesFromSubtree(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    var classNames = [];
    traverseNode(node, function (node) {
        if (node.nodeType !== 1)
            return;
        var className = node.getAttribute('class');
        if (className) {
            var names = className.split(/\s+/);
            for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
                var name_1 = names_1[_i];
                classNames.push(name_1);
            }
        }
    });
    return {
        classNames: (0, unique_1.default)(classNames),
    };
}
function copyTo(params) {
    var nodeId = params.nodeId, targetNodeId = params.targetNodeId;
    var node = (0, nodeManager_1.getNode)(nodeId);
    var targetNode = (0, nodeManager_1.getNode)(targetNodeId);
    var cloneNode = node.cloneNode(true);
    targetNode.appendChild(cloneNode);
    return {
        nodeId: (0, nodeManager_1.getNodeId)(cloneNode),
    };
}
var isEnable = false;
function enable() {
    isEnable = true;
    mutationObserver_1.default.disconnect();
    mutationObserver_1.default.observe(document.documentElement);
    nodeManager.clear();
}
function hookAttachShadow() {
    var origAttachShadow = Element.prototype.attachShadow;
    if (origAttachShadow) {
        Element.prototype.attachShadow = function (init) {
            var shadowRoot = origAttachShadow.apply(this, [init]);
            if (!nodeManager.isValidNode(this)) {
                return shadowRoot;
            }
            ;
            this.chobitsuShadowRoot = shadowRoot;
            if (isEnable) {
                mutationObserver_1.default.observe(shadowRoot);
                var hostId = (0, nodeManager_1.getNodeId)(this);
                if (hostId) {
                    connector_1.default.trigger('DOM.shadowRootPushed', {
                        hostId: hostId,
                        root: nodeManager.wrap(shadowRoot, { depth: 1 }),
                    });
                }
            }
            return shadowRoot;
        };
    }
}
hookAttachShadow();
function getDocument() {
    return {
        root: nodeManager.wrap(document, {
            depth: 2,
        }),
    };
}
function getOuterHTML(params) {
    var outerHTML = '';
    if (params.nodeId) {
        var node = (0, nodeManager_1.getNode)(params.nodeId);
        outerHTML = node.outerHTML;
    }
    return {
        outerHTML: outerHTML,
    };
}
function moveTo(params) {
    var nodeId = params.nodeId, targetNodeId = params.targetNodeId;
    var node = (0, nodeManager_1.getNode)(nodeId);
    var targetNode = (0, nodeManager_1.getNode)(targetNodeId);
    targetNode.appendChild(node);
    return {
        nodeId: (0, nodeManager_1.getNodeId)(node),
    };
}
var searchResults = new Map();
function performSearch(params) {
    var query = (0, lowerCase_1.default)(params.query);
    var result = [];
    try {
        result = (0, concat_1.default)(result, (0, toArr_1.default)(document.querySelectorAll(query)));
    }
    catch (e) {
    }
    try {
        result = (0, concat_1.default)(result, (0, xpath_1.default)(query));
    }
    catch (e) {
    }
    traverseNode(document, function (node) {
        var nodeType = node.nodeType;
        if (nodeType === 1) {
            var localName = node.localName;
            if ((0, contain_1.default)("<".concat(localName, " "), query) ||
                (0, contain_1.default)("</".concat(localName, ">"), query)) {
                result.push(node);
                return;
            }
            var attributes_1 = [];
            (0, each_1.default)(node.attributes, function (_a) {
                var name = _a.name, value = _a.value;
                return attributes_1.push(name, value);
            });
            for (var i = 0, len = attributes_1.length; i < len; i++) {
                if ((0, contain_1.default)((0, lowerCase_1.default)(attributes_1[i]), query)) {
                    result.push(node);
                    break;
                }
            }
        }
        else if (nodeType === 3) {
            if ((0, contain_1.default)((0, lowerCase_1.default)(node.nodeValue), query)) {
                result.push(node);
            }
        }
    });
    var searchId = (0, util_1.createId)();
    searchResults.set(searchId, result);
    return {
        searchId: searchId,
        resultCount: result.length,
    };
}
function getSearchResults(params) {
    var searchId = params.searchId, fromIndex = params.fromIndex, toIndex = params.toIndex;
    var searchResult = searchResults.get(searchId);
    var result = searchResult.slice(fromIndex, toIndex);
    var nodeIds = (0, map_1.default)(result, function (node) {
        var nodeId = (0, nodeManager_1.getNodeId)(node);
        if (!nodeId) {
            return pushNodesToFrontend(node);
        }
        return nodeId;
    });
    return {
        nodeIds: nodeIds,
    };
}
function pushNodesToFrontend(node) {
    var nodes = [node];
    var parentNode = node.parentNode;
    while (parentNode) {
        nodes.push(parentNode);
        var nodeId = (0, nodeManager_1.getNodeId)(parentNode);
        if (nodeId) {
            break;
        }
        else {
            parentNode = parentNode.parentNode;
        }
    }
    while (nodes.length) {
        var node_1 = nodes.pop();
        var nodeId = (0, nodeManager_1.getNodeId)(node_1);
        connector_1.default.trigger('DOM.setChildNodes', {
            parentId: nodeId,
            nodes: nodeManager.getChildNodes(node_1, 1),
        });
    }
    return (0, nodeManager_1.getNodeId)(node);
}
function discardSearchResults(params) {
    searchResults.delete(params.searchId);
}
function pushNodesByBackendIdsToFrontend(params) {
    return {
        nodeIds: params.backendNodeIds,
    };
}
function removeNode(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    (0, _1.default)(node).remove();
}
function requestChildNodes(params) {
    var nodeId = params.nodeId, _a = params.depth, depth = _a === void 0 ? 1 : _a;
    var node = (0, nodeManager_1.getNode)(nodeId);
    connector_1.default.trigger('DOM.setChildNodes', {
        parentId: nodeId,
        nodes: nodeManager.getChildNodes(node, depth),
    });
}
function requestNode(params) {
    var node = objManager.getObj(params.objectId);
    return {
        nodeId: (0, nodeManager_1.getNodeId)(node),
    };
}
function resolveNode(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    return {
        object: objManager.wrap(node),
    };
}
function setAttributesAsText(params) {
    var name = params.name, text = params.text, nodeId = params.nodeId;
    var node = (0, nodeManager_1.getNode)(nodeId);
    if (name) {
        node.removeAttribute(name);
    }
    (0, _1.default)(node).attr(parseAttributes(text));
}
function setAttributeValue(params) {
    var nodeId = params.nodeId, name = params.name, value = params.value;
    var node = (0, nodeManager_1.getNode)(nodeId);
    node.setAttribute(name, value);
}
var history = [];
function setInspectedNode(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    history.unshift(node);
    if (history.length > 5)
        history.pop();
    for (var i = 0; i < 5; i++) {
        (0, evaluate_1.setGlobal)("$".concat(i), history[i]);
    }
}
function setNodeValue(params) {
    var nodeId = params.nodeId, value = params.value;
    var node = (0, nodeManager_1.getNode)(nodeId);
    node.nodeValue = value;
}
function setOuterHTML(params) {
    var nodeId = params.nodeId, outerHTML = params.outerHTML;
    var node = (0, nodeManager_1.getNode)(nodeId);
    node.outerHTML = outerHTML;
}
function getDOMNodeId(params) {
    var node = params.node;
    return {
        nodeId: nodeManager.getOrCreateNodeId(node),
    };
}
function getDOMNode(params) {
    var nodeId = params.nodeId;
    return {
        node: (0, nodeManager_1.getNode)(nodeId),
    };
}
function getTopLayerElements() {
    return {
        nodeIds: [],
    };
}
function getNodesForSubtreeByStyle() {
    return {
        nodeIds: [],
    };
}
function parseAttributes(str) {
    str = "<div ".concat(str, "></div>");
    return html_1.default.parse(str)[0].attrs;
}
function traverseNode(node, cb) {
    var childNodes = nodeManager.filterNodes(node.childNodes);
    for (var i = 0, len = childNodes.length; i < len; i++) {
        var child = childNodes[i];
        cb(child);
        traverseNode(child, cb);
    }
}
mutationObserver_1.default.on('attributes', function (target, name) {
    var nodeId = (0, nodeManager_1.getNodeId)(target);
    if (!nodeId)
        return;
    var value = target.getAttribute(name);
    if ((0, isNull_1.default)(value)) {
        connector_1.default.trigger('DOM.attributeRemoved', {
            nodeId: nodeId,
            name: name,
        });
    }
    else {
        connector_1.default.trigger('DOM.attributeModified', {
            nodeId: nodeId,
            name: name,
            value: value,
        });
    }
});
mutationObserver_1.default.on('childList', function (target, addedNodes, removedNodes) {
    var parentNodeId = (0, nodeManager_1.getNodeId)(target);
    if (!parentNodeId)
        return;
    addedNodes = nodeManager.filterNodes(addedNodes);
    removedNodes = nodeManager.filterNodes(removedNodes);
    function childNodeCountUpdated() {
        connector_1.default.trigger('DOM.childNodeCountUpdated', {
            childNodeCount: nodeManager.wrap(target, {
                depth: 0,
            }).childNodeCount,
            nodeId: parentNodeId,
        });
    }
    if (!(0, isEmpty_1.default)(addedNodes)) {
        childNodeCountUpdated();
        for (var i = 0, len = addedNodes.length; i < len; i++) {
            var node = addedNodes[i];
            var previousNode = nodeManager.getPreviousNode(node);
            var previousNodeId = previousNode ? (0, nodeManager_1.getNodeId)(previousNode) : 0;
            var params = {
                node: nodeManager.wrap(node, {
                    depth: 0,
                }),
                parentNodeId: parentNodeId,
                previousNodeId: previousNodeId,
            };
            connector_1.default.trigger('DOM.childNodeInserted', params);
        }
    }
    if (!(0, isEmpty_1.default)(removedNodes)) {
        for (var i = 0, len = removedNodes.length; i < len; i++) {
            var node = removedNodes[i];
            var nodeId = (0, nodeManager_1.getNodeId)(node);
            if (!nodeId) {
                childNodeCountUpdated();
                break;
            }
            connector_1.default.trigger('DOM.childNodeRemoved', {
                nodeId: (0, nodeManager_1.getNodeId)(node),
                parentNodeId: parentNodeId,
            });
        }
    }
});
mutationObserver_1.default.on('characterData', function (target) {
    var nodeId = (0, nodeManager_1.getNodeId)(target);
    if (!nodeId)
        return;
    connector_1.default.trigger('DOM.characterDataModified', {
        characterData: target.nodeValue,
        nodeId: nodeId,
    });
});
